var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 4.6875L24.375 25.3125",
    stroke: "#2CC4A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5C11.25 23.4946 11.6451 24.4484 12.3483 25.1516C13.0516 25.8549 14.0054 26.25 15 26.25C15.9946 26.25 16.9484 25.8549 17.6516 25.1516C18.3549 24.4484 18.75 23.4946 18.75 22.5",
    stroke: "#2CC4A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8374 4.84676C12.121 4.11874 13.5732 3.74012 15.0488 3.74868C16.5245 3.75724 17.9722 4.15268 19.2473 4.89554C20.5224 5.6384 21.5803 6.7027 22.3156 7.9822C23.0508 9.26171 23.4376 10.7117 23.4374 12.1874C23.4374 15.5975 24.0796 18.4639 24.7347 20.1327",
    stroke: "#2CC4A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8182 22.5002H5.62522C5.46113 22.4992 5.30018 22.4552 5.15845 22.3725C5.01671 22.2898 4.89916 22.1714 4.81755 22.029C4.73593 21.8867 4.69311 21.7254 4.69336 21.5613C4.69361 21.3972 4.73692 21.236 4.81897 21.0939C5.59124 19.758 6.56272 16.3842 6.56272 12.1877C6.5599 10.4674 7.08556 8.78775 8.06858 7.37598",
    stroke: "#2CC4A2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSlash);
export default __webpack_public_path__ + "static/media/BellSlash.1f0957e9.svg";
export { ForwardRef as ReactComponent };